import * as React from 'react';

import { SectionHeading } from 'app/components/SectionHeading';
import { PlaceholderItem } from 'app/components/PlaceholderItem';

import { useStyles } from './FormPlaceholder.styles';
import { FormPlaceholderProps } from './FormPlaceholder.interfaces';

function FormPlaceholder(props: FormPlaceholderProps) {
  const { showLoadingAnimation } = props;

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.formRow}>
        <SectionHeading
          className={classes.heading}
          title={
            <PlaceholderItem
              classes={{
                root: classes.headingTitlePlaceholder,
              }}
              showLoadingAnimation={showLoadingAnimation}
            />
          }
        />
        <PlaceholderItem
          rows={3}
          classes={{
            root: classes.content,
          }}
          showLoadingAnimation={showLoadingAnimation}
        />
      </div>
      <div className={classes.formRow}>
        <SectionHeading
          className={classes.heading}
          title={
            <PlaceholderItem
              classes={{
                root: classes.headingTitlePlaceholder,
              }}
              showLoadingAnimation={showLoadingAnimation}
            />
          }
        />
        <PlaceholderItem
          rows={2}
          classes={{
            root: classes.content,
          }}
          showLoadingAnimation={showLoadingAnimation}
        />
      </div>
      <div className={classes.formRow}>
        <SectionHeading
          className={classes.heading}
          title={
            <PlaceholderItem
              classes={{
                root: classes.headingTitlePlaceholder,
              }}
              showLoadingAnimation={showLoadingAnimation}
            />
          }
        />
        <PlaceholderItem
          rows={4}
          classes={{
            root: classes.content,
          }}
          showLoadingAnimation={showLoadingAnimation}
        />
      </div>
    </div>
  );
}

export default FormPlaceholder;
